import { SelectionModel } from "@angular/cdk/collections";
import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { TableComponent } from "src/app/table.component";
import { Helpers } from "src/helpers/helpers";
import { ReportService } from "src/services/report.service";
import { CareplusOrdersService } from "src/services/careplus-orders.service";
import { CareplusPolicy } from "src/models/careplus-policy";
import { CareplusPolicyStatus } from "src/models/careplus.constants";
import { MAT_DATE_FORMATS } from "@angular/material/core";

export const DATE_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export class Customer {
  id: number;
  customerName: string;
  userName: string;
  requestType: string;
  vehicleType: string;
  date: string;
  amount: string;
  status: string;
}

@Component({
  selector: "app-careplus-orders",
  templateUrl: "./careplus-orders.component.html",
  styleUrls: ["./careplus-orders.component.css"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }],
})
export class CareplusOrdersComponent extends TableComponent<CareplusPolicy> {
  pageTitle = "Orders";
  error: any;
  baseColumns: string[] = [
    "id",
    "createdAt",
    "status",
    "ownerName",
    "email",
    "phoneNumber",
    "policyNumber",
    "policyStartDate",
    "policyEndDate",
    "totalMembers",
    "basePremium",
    "totalFees",
    "totalDueAmount",
    "discountAmount",
    "amountPaid",
    "promotionName",
    "couponCode",
    "paymentId",
    "paymentToken",
    "source",
    "referrerName",
    "insurer",
  ];

  get displayedColumns(): string[] {
    return this.isIssuanceReport
      ? [...this.baseColumns, "policyHolders", "memberId", "civilIds"]
      : this.baseColumns;
  }

  selection = new SelectionModel<any>(true, []);
  status: string = "all";
  search: string = "";
  issueDateFrom?: string;
  issueDateTo?: string;
  forAgency: boolean = false;
  @Input() isIssuanceReport: boolean = false;

  constructor(
    requestService: CareplusOrdersService,
    private _reportService: ReportService,
    private router: Router,
    private helper: Helpers,
  ) {
    super(requestService);
  }

  openPurchaseDetail(policy: CareplusPolicy): void {
    if (
      policy.transactionStatus == CareplusPolicyStatus.PAYMENT_DONE ||
      policy.transactionStatus == CareplusPolicyStatus.POLICY_ISSUED
    ) {
      this.router.navigate(["/careplus-orders/" + policy.id], {
        state: {
          policy: policy,
        },
      });
    }
  }

  onSubmit(): void {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  clearFilters(): void {
    this.search = "";
    this.issueDateFrom = undefined;
    this.issueDateTo = undefined;
    this.onSubmit();
  }

  getCount() {
    const { endDate } = this.getDateRange();

    const basePayload = {
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
    };

    return this.countService.getCount(basePayload);
  }

  getData() {
    const { endDate } = this.getDateRange();
    let pageSize = this.paginator.pageSize ? this.paginator.pageSize : 10;

    const basePayload = {
      skip: this.paginator.pageIndex * pageSize,
      take: pageSize,
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
      ...(this.isIssuanceReport && { issuanceReport: true }),
    };

    return basePayload;
  }

  downloadReport(isXLS: boolean) {
    const { endDate } = this.getDateRange();
    const data = {
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
      asXLS: isXLS,
      ...(this.isIssuanceReport && { issuanceReport: true }),
    };
    this._reportService.downloadReport("DownloadCareplusOrdersReport", data);
  }

  private getDateRange() {
    let endDate;

    if (this.issueDateTo) {
      const end = new Date(this.issueDateTo);

      endDate = new Date(
        Date.UTC(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          23,
          59,
          59,
          999,
        ),
      ).toISOString();
    }

    return { endDate };
  }
}
